const getIconColorForUse = (use, disabled, theme) => {
  if (disabled) {
    return 'inherit';
  }
  switch (use) {
    case 'on-dark':
      return theme.color['icon-interactive-on-fill-default'];
    case 'on-bright':
      return theme.color['icon-core-default'];
    case 'on-fill':
      return theme.color['specialty-link-on-fill-default'];
    case 'blue':
    case 'dark':
    case 'light':
    case 'mention':
      return theme.color['icon-interactive-default'];
    case 'danger':
      return theme.color['icon-alert-default'];
    case 'unstyled':
      return undefined;
    // No color override for unstyled.
    default:
      {
        const __exhaustiveCheck = use;
        throw new Error(`Unhandled \`use\` argument: ${use}`);
      }
  }
};
export const getLinkIconStyles = (use, disabled, theme) => {
  const color = getIconColorForUse(use, disabled, theme);
  return Object.assign({
    marginInlineEnd: theme.space['200'],
    verticalAlign: '-0.25em'
  }, color && {
    color
  });
};

/**
 * Computes the final link use based on the provided use and toolbar context.
 */
export const getComputedLinkUse = ({
  use,
  isInFilledToolbar
}) => {
  // because we're no longer clobbering link styles in toolbars, this needs to work across themes
  if (isInFilledToolbar) {
    // Always use on-fill in a filled toolbar unless it's danger
    if (use === 'danger') {
      return use;
    }
    return 'on-fill';
  }
  return use;
};